export const adminRoutes = [
  // tenants
  {
    path: '/tenants',
    name: 'tenants',
    component: () => import(/* webpackChunkName: "RunResults" */ '@/views/admin/TenantsView.vue'),
  },
  // users
  {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "RunResults" */ '@/views/admin/UsersView.vue'),
  },
  // system-config
  {
      path: '/system-config',
      name: 'systemConfiguration',
      component: () => import(/* webpackChunkName: "RunResults" */ '@/views/admin/SystemConfigurationView.vue'),
  },
  // questionnaire-config
  {
    path: '/questionnaire/504/editor',
    name: 'questionnaireEditor',
    component: () => import(/* webpackChunkName: "" */ '@/views/admin/QuestionnaireEditor.vue'),
  }
]